(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec560"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec560"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aqUTs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $798876f3dcb43993$export$71511d61b312f219; });
function $798876f3dcb43993$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("2l5av", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1b418d46aafa0962$export$71511d61b312f219; });

var $lU9k7 = parcelRequire("lU9k7");

var $b7zoR = parcelRequire("b7zoR");

var $hgWCA = parcelRequire("hgWCA");

var $hb0L4 = parcelRequire("hb0L4");
function $1b418d46aafa0962$export$71511d61b312f219(arr) {
    return (0, $lU9k7._)(arr) || (0, $b7zoR._)(arr) || (0, $hb0L4._)(arr) || (0, $hgWCA._)();
}

});
parcelRegister("lU9k7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ff260f652f2fcf52$export$71511d61b312f219; });

var $IM26N = parcelRequire("IM26N");
function $ff260f652f2fcf52$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $IM26N._)(arr);
}

});
parcelRegister("IM26N", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $08695e87d0b74b63$export$71511d61b312f219; });
function $08695e87d0b74b63$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("b7zoR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $818bcedd0892ef18$export$71511d61b312f219; });
function $818bcedd0892ef18$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("hgWCA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $033ebb78eb0c991c$export$71511d61b312f219; });
function $033ebb78eb0c991c$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("hb0L4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c8140d49fd6310ae$export$71511d61b312f219; });

var $IM26N = parcelRequire("IM26N");
function $c8140d49fd6310ae$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $IM26N._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $IM26N._)(o, minLen);
}

});



var $aqUTs = parcelRequire("aqUTs");
function $b766c0138026c79b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b766c0138026c79b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b766c0138026c79b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b766c0138026c79b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $b766c0138026c79b$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $b766c0138026c79b$var$CREATED = 1;
var $b766c0138026c79b$var$MOUNTED = 2;
var $b766c0138026c79b$var$IDLE = 3;
var $b766c0138026c79b$var$MOVING = 4;
var $b766c0138026c79b$var$SCROLLING = 5;
var $b766c0138026c79b$var$DRAGGING = 6;
var $b766c0138026c79b$var$DESTROYED = 7;
var $b766c0138026c79b$var$STATES = {
    CREATED: $b766c0138026c79b$var$CREATED,
    MOUNTED: $b766c0138026c79b$var$MOUNTED,
    IDLE: $b766c0138026c79b$var$IDLE,
    MOVING: $b766c0138026c79b$var$MOVING,
    SCROLLING: $b766c0138026c79b$var$SCROLLING,
    DRAGGING: $b766c0138026c79b$var$DRAGGING,
    DESTROYED: $b766c0138026c79b$var$DESTROYED
};
function $b766c0138026c79b$var$empty(array) {
    array.length = 0;
}
function $b766c0138026c79b$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $b766c0138026c79b$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($b766c0138026c79b$var$slice(arguments, 1)));
}
var $b766c0138026c79b$var$nextTick = setTimeout;
var $b766c0138026c79b$var$noop = function noop() {};
function $b766c0138026c79b$var$raf(func) {
    return requestAnimationFrame(func);
}
function $b766c0138026c79b$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $aqUTs._)(subject)) === type;
}
function $b766c0138026c79b$var$isObject(subject) {
    return !$b766c0138026c79b$var$isNull(subject) && $b766c0138026c79b$var$typeOf("object", subject);
}
var $b766c0138026c79b$var$isArray = Array.isArray;
var $b766c0138026c79b$var$isFunction = $b766c0138026c79b$var$apply($b766c0138026c79b$var$typeOf, "function");
var $b766c0138026c79b$var$isString = $b766c0138026c79b$var$apply($b766c0138026c79b$var$typeOf, "string");
var $b766c0138026c79b$var$isUndefined = $b766c0138026c79b$var$apply($b766c0138026c79b$var$typeOf, "undefined");
function $b766c0138026c79b$var$isNull(subject) {
    return subject === null;
}
function $b766c0138026c79b$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $b766c0138026c79b$var$toArray(value) {
    return $b766c0138026c79b$var$isArray(value) ? value : [
        value
    ];
}
function $b766c0138026c79b$var$forEach(values, iteratee) {
    $b766c0138026c79b$var$toArray(values).forEach(iteratee);
}
function $b766c0138026c79b$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $b766c0138026c79b$var$push(array, items) {
    array.push.apply(array, $b766c0138026c79b$var$toArray(items));
    return array;
}
function $b766c0138026c79b$var$toggleClass(elm, classes, add) {
    if (elm) $b766c0138026c79b$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $b766c0138026c79b$var$addClass(elm, classes) {
    $b766c0138026c79b$var$toggleClass(elm, $b766c0138026c79b$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $b766c0138026c79b$var$append(parent, children) {
    $b766c0138026c79b$var$forEach(children, parent.appendChild.bind(parent));
}
function $b766c0138026c79b$var$before(nodes, ref) {
    $b766c0138026c79b$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $b766c0138026c79b$var$matches(elm, selector) {
    return $b766c0138026c79b$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $b766c0138026c79b$var$children(parent, selector) {
    var children2 = parent ? $b766c0138026c79b$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $b766c0138026c79b$var$matches(child, selector);
    }) : children2;
}
function $b766c0138026c79b$var$child(parent, selector) {
    return selector ? $b766c0138026c79b$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $b766c0138026c79b$var$ownKeys = Object.keys;
function $b766c0138026c79b$var$forOwn(object, iteratee, right) {
    if (object) (right ? $b766c0138026c79b$var$ownKeys(object).reverse() : $b766c0138026c79b$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $b766c0138026c79b$var$assign(object) {
    $b766c0138026c79b$var$slice(arguments, 1).forEach(function(source) {
        $b766c0138026c79b$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $b766c0138026c79b$var$merge(object) {
    $b766c0138026c79b$var$slice(arguments, 1).forEach(function(source) {
        $b766c0138026c79b$var$forOwn(source, function(value, key) {
            if ($b766c0138026c79b$var$isArray(value)) object[key] = value.slice();
            else if ($b766c0138026c79b$var$isObject(value)) object[key] = $b766c0138026c79b$var$merge({}, $b766c0138026c79b$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $b766c0138026c79b$var$omit(object, keys) {
    $b766c0138026c79b$var$forEach(keys || $b766c0138026c79b$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $b766c0138026c79b$var$removeAttribute(elms, attrs) {
    $b766c0138026c79b$var$forEach(elms, function(elm) {
        $b766c0138026c79b$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $b766c0138026c79b$var$setAttribute(elms, attrs, value) {
    if ($b766c0138026c79b$var$isObject(attrs)) $b766c0138026c79b$var$forOwn(attrs, function(value2, name) {
        $b766c0138026c79b$var$setAttribute(elms, name, value2);
    });
    else $b766c0138026c79b$var$forEach(elms, function(elm) {
        $b766c0138026c79b$var$isNull(value) || value === "" ? $b766c0138026c79b$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $b766c0138026c79b$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $b766c0138026c79b$var$isString(attrs) ? $b766c0138026c79b$var$addClass(elm, attrs) : $b766c0138026c79b$var$setAttribute(elm, attrs);
    parent && $b766c0138026c79b$var$append(parent, elm);
    return elm;
}
function $b766c0138026c79b$var$style(elm, prop, value) {
    if ($b766c0138026c79b$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$b766c0138026c79b$var$isNull(value)) elm.style[prop] = "" + value;
}
function $b766c0138026c79b$var$display(elm, display2) {
    $b766c0138026c79b$var$style(elm, "display", display2);
}
function $b766c0138026c79b$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $b766c0138026c79b$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $b766c0138026c79b$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $b766c0138026c79b$var$rect(target) {
    return target.getBoundingClientRect();
}
function $b766c0138026c79b$var$remove(nodes) {
    $b766c0138026c79b$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $b766c0138026c79b$var$parseHtml(html) {
    return $b766c0138026c79b$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $b766c0138026c79b$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $b766c0138026c79b$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $b766c0138026c79b$var$queryAll(parent, selector) {
    return selector ? $b766c0138026c79b$var$slice(parent.querySelectorAll(selector)) : [];
}
function $b766c0138026c79b$var$removeClass(elm, classes) {
    $b766c0138026c79b$var$toggleClass(elm, classes, false);
}
function $b766c0138026c79b$var$timeOf(e) {
    return e.timeStamp;
}
function $b766c0138026c79b$var$unit(value) {
    return $b766c0138026c79b$var$isString(value) ? value : value ? value + "px" : "";
}
var $b766c0138026c79b$var$PROJECT_CODE = "splide";
var $b766c0138026c79b$var$DATA_ATTRIBUTE = "data-" + $b766c0138026c79b$var$PROJECT_CODE;
function $b766c0138026c79b$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $b766c0138026c79b$var$PROJECT_CODE + "] " + (message || ""));
}
var $b766c0138026c79b$var$min = Math.min, $b766c0138026c79b$var$max = Math.max, $b766c0138026c79b$var$floor = Math.floor, $b766c0138026c79b$var$ceil = Math.ceil, $b766c0138026c79b$var$abs = Math.abs;
function $b766c0138026c79b$var$approximatelyEqual(x, y, epsilon) {
    return $b766c0138026c79b$var$abs(x - y) < epsilon;
}
function $b766c0138026c79b$var$between(number, x, y, exclusive) {
    var minimum = $b766c0138026c79b$var$min(x, y);
    var maximum = $b766c0138026c79b$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $b766c0138026c79b$var$clamp(number, x, y) {
    var minimum = $b766c0138026c79b$var$min(x, y);
    var maximum = $b766c0138026c79b$var$max(x, y);
    return $b766c0138026c79b$var$min($b766c0138026c79b$var$max(minimum, number), maximum);
}
function $b766c0138026c79b$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $b766c0138026c79b$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $b766c0138026c79b$var$format(string, replacements) {
    $b766c0138026c79b$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $b766c0138026c79b$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $b766c0138026c79b$var$ids = {};
function $b766c0138026c79b$var$uniqueId(prefix) {
    return "" + prefix + $b766c0138026c79b$var$pad($b766c0138026c79b$var$ids[prefix] = ($b766c0138026c79b$var$ids[prefix] || 0) + 1);
}
function $b766c0138026c79b$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $b766c0138026c79b$var$forEach(targets, function(target) {
            target && $b766c0138026c79b$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $b766c0138026c79b$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $b766c0138026c79b$export$d300dc1a2634364b = "mounted";
var $b766c0138026c79b$export$d8dac49b4532735a = "ready";
var $b766c0138026c79b$export$2aa493d7c3275167 = "move";
var $b766c0138026c79b$export$fe5802204b967f0d = "moved";
var $b766c0138026c79b$export$5adb665701eda1ce = "click";
var $b766c0138026c79b$export$92e3eae133acac4c = "active";
var $b766c0138026c79b$export$6bcbb81035c12cea = "inactive";
var $b766c0138026c79b$export$6a5b3445e4066a53 = "visible";
var $b766c0138026c79b$export$8c5c7a21d54563e9 = "hidden";
var $b766c0138026c79b$export$7f4701ac5e05e39f = "refresh";
var $b766c0138026c79b$export$db40ab7c0855fa5c = "updated";
var $b766c0138026c79b$export$7e019dae5103a285 = "resize";
var $b766c0138026c79b$export$d637eba1e9e28482 = "resized";
var $b766c0138026c79b$export$e84bf5065c9087ac = "drag";
var $b766c0138026c79b$export$8e9f636d2c722196 = "dragging";
var $b766c0138026c79b$export$90ea576bd3fdeb60 = "dragged";
var $b766c0138026c79b$export$49801896908b5e33 = "scroll";
var $b766c0138026c79b$export$ff8164bff3202b9 = "scrolled";
var $b766c0138026c79b$export$6cbac5b662a31e1b = "overflow";
var $b766c0138026c79b$export$88c4cf7419e470cd = "destroy";
var $b766c0138026c79b$export$8647f6b043e04e9d = "arrows:mounted";
var $b766c0138026c79b$export$d467f9343b961f75 = "arrows:updated";
var $b766c0138026c79b$export$bf89a4e4349c9778 = "pagination:mounted";
var $b766c0138026c79b$export$eb2019082ed6de0b = "pagination:updated";
var $b766c0138026c79b$export$84015c33508f94ec = "navigation:mounted";
var $b766c0138026c79b$export$23663268a31b79e2 = "autoplay:play";
var $b766c0138026c79b$export$185723258309b608 = "autoplay:playing";
var $b766c0138026c79b$export$16a1e4f3d0368265 = "autoplay:pause";
var $b766c0138026c79b$export$9f64346e17f0ec8e = "lazyload:loaded";
var $b766c0138026c79b$export$6d5af59619d10e6a = "sk";
var $b766c0138026c79b$export$f0af896383d5adff = "sh";
var $b766c0138026c79b$export$28dea85f216954dc = "ei";
function $b766c0138026c79b$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $b766c0138026c79b$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $b766c0138026c79b$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $b766c0138026c79b$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $b766c0138026c79b$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($b766c0138026c79b$export$88c4cf7419e470cd, binder.destroy);
    return $b766c0138026c79b$var$assign(binder, {
        bus: bus,
        on: on,
        off: $b766c0138026c79b$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $b766c0138026c79b$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $b766c0138026c79b$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $b766c0138026c79b$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $b766c0138026c79b$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $b766c0138026c79b$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $b766c0138026c79b$var$includes($b766c0138026c79b$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $b766c0138026c79b$export$efff0f5979573c99(func, duration) {
    var interval = $b766c0138026c79b$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $b766c0138026c79b$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $b766c0138026c79b$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $b766c0138026c79b$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $b766c0138026c79b$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($b766c0138026c79b$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $b766c0138026c79b$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $b766c0138026c79b$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($b766c0138026c79b$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $b766c0138026c79b$var$merge(options, reducedMotion) : $b766c0138026c79b$var$omit(options, $b766c0138026c79b$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $b766c0138026c79b$var$merge(options, opts);
        base && $b766c0138026c79b$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($b766c0138026c79b$var$CREATED)) Splide2.emit($b766c0138026c79b$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $b766c0138026c79b$var$ARROW = "Arrow";
var $b766c0138026c79b$var$ARROW_LEFT = $b766c0138026c79b$var$ARROW + "Left";
var $b766c0138026c79b$var$ARROW_RIGHT = $b766c0138026c79b$var$ARROW + "Right";
var $b766c0138026c79b$var$ARROW_UP = $b766c0138026c79b$var$ARROW + "Up";
var $b766c0138026c79b$var$ARROW_DOWN = $b766c0138026c79b$var$ARROW + "Down";
var $b766c0138026c79b$export$373e92e0788ff06e = "ltr";
var $b766c0138026c79b$export$850f7749a2909601 = "rtl";
var $b766c0138026c79b$export$97170d9824b89709 = "ttb";
var $b766c0138026c79b$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $b766c0138026c79b$var$ARROW_UP,
        $b766c0138026c79b$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $b766c0138026c79b$var$ARROW_DOWN,
        $b766c0138026c79b$var$ARROW_LEFT
    ]
};
function $b766c0138026c79b$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $b766c0138026c79b$export$850f7749a2909601 && !axisOnly ? 1 : direction === $b766c0138026c79b$export$97170d9824b89709 ? 0 : -1;
        return $b766c0138026c79b$var$ORIENTATION_MAP[prop] && $b766c0138026c79b$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $b766c0138026c79b$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $b766c0138026c79b$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $b766c0138026c79b$var$ROLE = "role";
var $b766c0138026c79b$var$TAB_INDEX = "tabindex";
var $b766c0138026c79b$var$DISABLED = "disabled";
var $b766c0138026c79b$var$ARIA_PREFIX = "aria-";
var $b766c0138026c79b$var$ARIA_CONTROLS = $b766c0138026c79b$var$ARIA_PREFIX + "controls";
var $b766c0138026c79b$var$ARIA_CURRENT = $b766c0138026c79b$var$ARIA_PREFIX + "current";
var $b766c0138026c79b$var$ARIA_SELECTED = $b766c0138026c79b$var$ARIA_PREFIX + "selected";
var $b766c0138026c79b$var$ARIA_LABEL = $b766c0138026c79b$var$ARIA_PREFIX + "label";
var $b766c0138026c79b$var$ARIA_LABELLEDBY = $b766c0138026c79b$var$ARIA_PREFIX + "labelledby";
var $b766c0138026c79b$var$ARIA_HIDDEN = $b766c0138026c79b$var$ARIA_PREFIX + "hidden";
var $b766c0138026c79b$var$ARIA_ORIENTATION = $b766c0138026c79b$var$ARIA_PREFIX + "orientation";
var $b766c0138026c79b$var$ARIA_ROLEDESCRIPTION = $b766c0138026c79b$var$ARIA_PREFIX + "roledescription";
var $b766c0138026c79b$var$ARIA_LIVE = $b766c0138026c79b$var$ARIA_PREFIX + "live";
var $b766c0138026c79b$var$ARIA_BUSY = $b766c0138026c79b$var$ARIA_PREFIX + "busy";
var $b766c0138026c79b$var$ARIA_ATOMIC = $b766c0138026c79b$var$ARIA_PREFIX + "atomic";
var $b766c0138026c79b$var$ALL_ATTRIBUTES = [
    $b766c0138026c79b$var$ROLE,
    $b766c0138026c79b$var$TAB_INDEX,
    $b766c0138026c79b$var$DISABLED,
    $b766c0138026c79b$var$ARIA_CONTROLS,
    $b766c0138026c79b$var$ARIA_CURRENT,
    $b766c0138026c79b$var$ARIA_LABEL,
    $b766c0138026c79b$var$ARIA_LABELLEDBY,
    $b766c0138026c79b$var$ARIA_HIDDEN,
    $b766c0138026c79b$var$ARIA_ORIENTATION,
    $b766c0138026c79b$var$ARIA_ROLEDESCRIPTION
];
var $b766c0138026c79b$var$CLASS_PREFIX = $b766c0138026c79b$var$PROJECT_CODE + "__";
var $b766c0138026c79b$var$STATUS_CLASS_PREFIX = "is-";
var $b766c0138026c79b$export$93b21159ad85c843 = $b766c0138026c79b$var$PROJECT_CODE;
var $b766c0138026c79b$export$7738b09ac0a98952 = $b766c0138026c79b$var$CLASS_PREFIX + "track";
var $b766c0138026c79b$export$19cc2a5451235cae = $b766c0138026c79b$var$CLASS_PREFIX + "list";
var $b766c0138026c79b$export$8d922915837a38d3 = $b766c0138026c79b$var$CLASS_PREFIX + "slide";
var $b766c0138026c79b$export$2c1ba4a4f1aa4947 = $b766c0138026c79b$export$8d922915837a38d3 + "--clone";
var $b766c0138026c79b$export$e9ba7e444ba60a12 = $b766c0138026c79b$export$8d922915837a38d3 + "__container";
var $b766c0138026c79b$export$a26cbd955fecf11e = $b766c0138026c79b$var$CLASS_PREFIX + "arrows";
var $b766c0138026c79b$export$516e7d18e13a2dca = $b766c0138026c79b$var$CLASS_PREFIX + "arrow";
var $b766c0138026c79b$export$58ea3db24c33b76 = $b766c0138026c79b$export$516e7d18e13a2dca + "--prev";
var $b766c0138026c79b$export$4885afd7098a65c2 = $b766c0138026c79b$export$516e7d18e13a2dca + "--next";
var $b766c0138026c79b$export$cbf8e5a0ab95eda3 = $b766c0138026c79b$var$CLASS_PREFIX + "pagination";
var $b766c0138026c79b$export$52f2cca6a5eee805 = $b766c0138026c79b$export$cbf8e5a0ab95eda3 + "__page";
var $b766c0138026c79b$export$4c82dc32b1c4ace5 = $b766c0138026c79b$var$CLASS_PREFIX + "progress";
var $b766c0138026c79b$export$2c9b091c749f4409 = $b766c0138026c79b$export$4c82dc32b1c4ace5 + "__bar";
var $b766c0138026c79b$export$a29701deef84b825 = $b766c0138026c79b$var$CLASS_PREFIX + "toggle";
var $b766c0138026c79b$export$d9d247d51b430dbb = $b766c0138026c79b$export$a29701deef84b825 + "__play";
var $b766c0138026c79b$export$3529f201a419925b = $b766c0138026c79b$export$a29701deef84b825 + "__pause";
var $b766c0138026c79b$export$3e5381ee3fab8374 = $b766c0138026c79b$var$CLASS_PREFIX + "spinner";
var $b766c0138026c79b$export$bb78d7c200da8960 = $b766c0138026c79b$var$CLASS_PREFIX + "sr";
var $b766c0138026c79b$export$7761661e2d5b9388 = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "initialized";
var $b766c0138026c79b$export$72d36ecf3758cb4b = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "active";
var $b766c0138026c79b$export$e423ac4972f5e196 = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "prev";
var $b766c0138026c79b$export$457a2d20827a2779 = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "next";
var $b766c0138026c79b$export$53ca4621bbab9a = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "visible";
var $b766c0138026c79b$export$d22ec4ccb7996ba2 = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "loading";
var $b766c0138026c79b$export$b6f202a162a09100 = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "focus-in";
var $b766c0138026c79b$export$cd908cd1dd625e29 = $b766c0138026c79b$var$STATUS_CLASS_PREFIX + "overflow";
var $b766c0138026c79b$export$49f9eaea10ebf193 = [
    $b766c0138026c79b$export$72d36ecf3758cb4b,
    $b766c0138026c79b$export$53ca4621bbab9a,
    $b766c0138026c79b$export$e423ac4972f5e196,
    $b766c0138026c79b$export$457a2d20827a2779,
    $b766c0138026c79b$export$d22ec4ccb7996ba2,
    $b766c0138026c79b$export$b6f202a162a09100,
    $b766c0138026c79b$export$cd908cd1dd625e29
];
var $b766c0138026c79b$export$ba41d43e4a419565 = {
    slide: $b766c0138026c79b$export$8d922915837a38d3,
    clone: $b766c0138026c79b$export$2c1ba4a4f1aa4947,
    arrows: $b766c0138026c79b$export$a26cbd955fecf11e,
    arrow: $b766c0138026c79b$export$516e7d18e13a2dca,
    prev: $b766c0138026c79b$export$58ea3db24c33b76,
    next: $b766c0138026c79b$export$4885afd7098a65c2,
    pagination: $b766c0138026c79b$export$cbf8e5a0ab95eda3,
    page: $b766c0138026c79b$export$52f2cca6a5eee805,
    spinner: $b766c0138026c79b$export$3e5381ee3fab8374
};
function $b766c0138026c79b$var$closest(from, selector) {
    if ($b766c0138026c79b$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($b766c0138026c79b$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $b766c0138026c79b$var$FRICTION = 5;
var $b766c0138026c79b$var$LOG_INTERVAL = 200;
var $b766c0138026c79b$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $b766c0138026c79b$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $b766c0138026c79b$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $b766c0138026c79b$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($b766c0138026c79b$export$7f4701ac5e05e39f, destroy);
        on($b766c0138026c79b$export$7f4701ac5e05e39f, setup);
        on($b766c0138026c79b$export$db40ab7c0855fa5c, update);
        bind(document, $b766c0138026c79b$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $b766c0138026c79b$var$toggleClass(root, $b766c0138026c79b$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $b766c0138026c79b$var$ALL_ATTRIBUTES.concat("style");
        $b766c0138026c79b$var$empty(slides);
        $b766c0138026c79b$var$removeClass(root, rootClasses);
        $b766c0138026c79b$var$removeClass(track, trackClasses);
        $b766c0138026c79b$var$removeAttribute([
            track,
            list
        ], attrs);
        $b766c0138026c79b$var$removeAttribute(root, completely ? attrs : [
            "style",
            $b766c0138026c79b$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $b766c0138026c79b$var$removeClass(root, rootClasses);
        $b766c0138026c79b$var$removeClass(track, trackClasses);
        rootClasses = getClasses($b766c0138026c79b$export$93b21159ad85c843);
        trackClasses = getClasses($b766c0138026c79b$export$7738b09ac0a98952);
        $b766c0138026c79b$var$addClass(root, rootClasses);
        $b766c0138026c79b$var$addClass(track, trackClasses);
        $b766c0138026c79b$var$setAttribute(root, $b766c0138026c79b$var$ARIA_LABEL, options.label);
        $b766c0138026c79b$var$setAttribute(root, $b766c0138026c79b$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $b766c0138026c79b$export$7738b09ac0a98952);
        list = $b766c0138026c79b$var$child(track, "." + $b766c0138026c79b$export$19cc2a5451235cae);
        $b766c0138026c79b$var$assert(track && list, "A track/list element is missing.");
        $b766c0138026c79b$var$push(slides, $b766c0138026c79b$var$children(list, "." + $b766c0138026c79b$export$8d922915837a38d3 + ":not(." + $b766c0138026c79b$export$2c1ba4a4f1aa4947 + ")"));
        $b766c0138026c79b$var$forOwn({
            arrows: $b766c0138026c79b$export$a26cbd955fecf11e,
            pagination: $b766c0138026c79b$export$cbf8e5a0ab95eda3,
            prev: $b766c0138026c79b$export$58ea3db24c33b76,
            next: $b766c0138026c79b$export$4885afd7098a65c2,
            bar: $b766c0138026c79b$export$2c9b091c749f4409,
            toggle: $b766c0138026c79b$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $b766c0138026c79b$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $b766c0138026c79b$var$uniqueId($b766c0138026c79b$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$b766c0138026c79b$var$getAttribute(root, $b766c0138026c79b$var$ROLE) && root.tagName !== "SECTION" && role) $b766c0138026c79b$var$setAttribute(root, $b766c0138026c79b$var$ROLE, role);
        $b766c0138026c79b$var$setAttribute(root, $b766c0138026c79b$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $b766c0138026c79b$var$setAttribute(list, $b766c0138026c79b$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $b766c0138026c79b$var$query(root, selector);
        return elm && $b766c0138026c79b$var$closest(elm, "." + $b766c0138026c79b$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $b766c0138026c79b$export$93b21159ad85c843 && $b766c0138026c79b$export$72d36ecf3758cb4b
        ];
    }
    return $b766c0138026c79b$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $b766c0138026c79b$export$e5a58a5ee5b54c22 = "slide";
var $b766c0138026c79b$export$f42383286ed1223d = "loop";
var $b766c0138026c79b$export$742b62a5690c060 = "fade";
function $b766c0138026c79b$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $b766c0138026c79b$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $b766c0138026c79b$var$getAttribute(slide, "style");
    var label = $b766c0138026c79b$var$getAttribute(slide, $b766c0138026c79b$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $b766c0138026c79b$var$child(slide, "." + $b766c0138026c79b$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $b766c0138026c79b$var$pad(index + 1);
            $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ROLE, pagination ? "tabpanel" : "group");
            $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ARIA_LABEL, label || $b766c0138026c79b$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $b766c0138026c79b$var$apply(emit, $b766c0138026c79b$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $b766c0138026c79b$var$apply(emit, $b766c0138026c79b$export$6d5af59619d10e6a, self));
        on([
            $b766c0138026c79b$export$fe5802204b967f0d,
            $b766c0138026c79b$export$f0af896383d5adff,
            $b766c0138026c79b$export$ff8164bff3202b9
        ], update);
        on($b766c0138026c79b$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($b766c0138026c79b$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $b766c0138026c79b$var$removeClass(slide, $b766c0138026c79b$export$49f9eaea10ebf193);
        $b766c0138026c79b$var$removeAttribute(slide, $b766c0138026c79b$var$ALL_ATTRIBUTES);
        $b766c0138026c79b$var$setAttribute(slide, "style", styles);
        $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ARIA_LABEL, $b766c0138026c79b$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ARIA_CONTROLS, controls);
        $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $b766c0138026c79b$var$removeAttribute(slide, $b766c0138026c79b$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $b766c0138026c79b$var$toggleClass(slide, $b766c0138026c79b$export$e423ac4972f5e196, index === curr - 1);
            $b766c0138026c79b$var$toggleClass(slide, $b766c0138026c79b$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $b766c0138026c79b$var$hasClass(slide, $b766c0138026c79b$export$72d36ecf3758cb4b)) {
            $b766c0138026c79b$var$toggleClass(slide, $b766c0138026c79b$export$72d36ecf3758cb4b, active);
            $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $b766c0138026c79b$export$92e3eae133acac4c : $b766c0138026c79b$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $b766c0138026c79b$var$MOVING,
            $b766c0138026c79b$var$SCROLLING
        ])) $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$ARIA_HIDDEN, hidden || "");
        $b766c0138026c79b$var$setAttribute($b766c0138026c79b$var$queryAll(slide, options.focusableNodes || ""), $b766c0138026c79b$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $b766c0138026c79b$var$setAttribute(slide, $b766c0138026c79b$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $b766c0138026c79b$var$hasClass(slide, $b766c0138026c79b$export$53ca4621bbab9a)) {
            $b766c0138026c79b$var$toggleClass(slide, $b766c0138026c79b$export$53ca4621bbab9a, visible);
            emit(visible ? $b766c0138026c79b$export$6a5b3445e4066a53 : $b766c0138026c79b$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $b766c0138026c79b$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $b766c0138026c79b$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($b766c0138026c79b$export$742b62a5690c060)) return isActive();
        var trackRect = $b766c0138026c79b$var$rect(Components.Elements.track);
        var slideRect = $b766c0138026c79b$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $b766c0138026c79b$var$floor(trackRect[left]) <= $b766c0138026c79b$var$ceil(slideRect[left]) && $b766c0138026c79b$var$floor(slideRect[right]) <= $b766c0138026c79b$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $b766c0138026c79b$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($b766c0138026c79b$export$f42383286ed1223d))) diff = $b766c0138026c79b$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $b766c0138026c79b$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($b766c0138026c79b$export$7f4701ac5e05e39f, destroy);
        on($b766c0138026c79b$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $b766c0138026c79b$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $b766c0138026c79b$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var _$Controller = Components2.Controller;
        var index = _$Controller.toIndex(page);
        var max = _$Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $b766c0138026c79b$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $b766c0138026c79b$var$forEach(items, function(slide) {
            if ($b766c0138026c79b$var$isString(slide)) slide = $b766c0138026c79b$var$parseHtml(slide);
            if ($b766c0138026c79b$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $b766c0138026c79b$var$before(slide, ref) : $b766c0138026c79b$var$append(list, slide);
                $b766c0138026c79b$var$addClass(slide, options.classes.slide);
                observeImages(slide, $b766c0138026c79b$var$apply(emit, $b766c0138026c79b$export$7e019dae5103a285));
            }
        });
        emit($b766c0138026c79b$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $b766c0138026c79b$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($b766c0138026c79b$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($b766c0138026c79b$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $b766c0138026c79b$var$isString(matcher) ? $b766c0138026c79b$var$matches(Slide2.slide, matcher) : $b766c0138026c79b$var$includes($b766c0138026c79b$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $b766c0138026c79b$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $b766c0138026c79b$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = _$Slides.getAt, styleSlides = _$Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $b766c0138026c79b$export$efff0f5979573c99($b766c0138026c79b$var$apply(emit, $b766c0138026c79b$export$7e019dae5103a285)));
        on([
            $b766c0138026c79b$export$db40ab7c0855fa5c,
            $b766c0138026c79b$export$7f4701ac5e05e39f
        ], init);
        on($b766c0138026c79b$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $b766c0138026c79b$export$97170d9824b89709;
        $b766c0138026c79b$var$style(root, "maxWidth", $b766c0138026c79b$var$unit(options.width));
        $b766c0138026c79b$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $b766c0138026c79b$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $b766c0138026c79b$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $b766c0138026c79b$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $b766c0138026c79b$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($b766c0138026c79b$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $b766c0138026c79b$var$toggleClass(root, $b766c0138026c79b$export$cd908cd1dd625e29, overflow);
                emit($b766c0138026c79b$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $b766c0138026c79b$var$unit(padding[prop] || ($b766c0138026c79b$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $b766c0138026c79b$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $b766c0138026c79b$var$unit(options.height || $b766c0138026c79b$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $b766c0138026c79b$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $b766c0138026c79b$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $b766c0138026c79b$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $b766c0138026c79b$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $b766c0138026c79b$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $b766c0138026c79b$var$rect(Slide.slide)[resolve("right")];
            var left = $b766c0138026c79b$var$rect(list)[resolve("left")];
            return $b766c0138026c79b$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($b766c0138026c79b$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($b766c0138026c79b$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($b766c0138026c79b$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $b766c0138026c79b$var$MULTIPLIER = 2;
function $b766c0138026c79b$var$Clones(Splide2, Components2, options) {
    var event = $b766c0138026c79b$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var _$Elements = Components2.Elements, _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($b766c0138026c79b$export$7f4701ac5e05e39f, remount);
        on([
            $b766c0138026c79b$export$db40ab7c0855fa5c,
            $b766c0138026c79b$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $b766c0138026c79b$var$remove(clones);
        $b766c0138026c79b$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($b766c0138026c79b$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = _$Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$b766c0138026c79b$var$push(slides, slides);
            $b766c0138026c79b$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $b766c0138026c79b$var$before(clone, slides[0].slide) : $b766c0138026c79b$var$append(_$Elements.list, clone);
                $b766c0138026c79b$var$push(clones, clone);
                _$Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $b766c0138026c79b$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $b766c0138026c79b$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($b766c0138026c79b$export$f42383286ed1223d)) clones2 = 0;
        else if ($b766c0138026c79b$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $b766c0138026c79b$var$ceil($b766c0138026c79b$var$rect(_$Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $b766c0138026c79b$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $b766c0138026c79b$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $b766c0138026c79b$export$d300dc1a2634364b,
            $b766c0138026c79b$export$d637eba1e9e28482,
            $b766c0138026c79b$export$db40ab7c0855fa5c,
            $b766c0138026c79b$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($b766c0138026c79b$var$MOVING);
        emit($b766c0138026c79b$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($b766c0138026c79b$var$IDLE);
            emit($b766c0138026c79b$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($b766c0138026c79b$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $b766c0138026c79b$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($b766c0138026c79b$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($b766c0138026c79b$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($b766c0138026c79b$var$ceil($b766c0138026c79b$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var _$Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < _$Slides.length; i++){
            var slideIndex = _$Slides[i].index;
            var distance = $b766c0138026c79b$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $b766c0138026c79b$var$rect(list)[left] - $b766c0138026c79b$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($b766c0138026c79b$export$e5a58a5ee5b54c22)) position = $b766c0138026c79b$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $b766c0138026c79b$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $b766c0138026c79b$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $b766c0138026c79b$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, toPosition = _$Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($b766c0138026c79b$export$f42383286ed1223d);
    var isSlide = Splide2.is($b766c0138026c79b$export$e5a58a5ee5b54c22);
    var getNext = $b766c0138026c79b$var$apply(getAdjacent, false);
    var getPrev = $b766c0138026c79b$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $b766c0138026c79b$export$db40ab7c0855fa5c,
            $b766c0138026c79b$export$7f4701ac5e05e39f,
            $b766c0138026c79b$export$28dea85f216954dc
        ], init);
        on($b766c0138026c79b$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $b766c0138026c79b$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            _$Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($b766c0138026c79b$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                _$Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(_$Move.toIndex(getPosition()));
            setIndex(omitEnd ? $b766c0138026c79b$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($b766c0138026c79b$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $b766c0138026c79b$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$b766c0138026c79b$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($b766c0138026c79b$var$between(0, dest, from, true) || $b766c0138026c79b$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $b766c0138026c79b$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $b766c0138026c79b$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $b766c0138026c79b$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $b766c0138026c79b$var$min(index, endIndex) : $b766c0138026c79b$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = _$Move.toIndex(destination);
        return isSlide ? $b766c0138026c79b$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$b766c0138026c79b$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $b766c0138026c79b$var$MOVING,
            $b766c0138026c79b$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $b766c0138026c79b$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $b766c0138026c79b$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $b766c0138026c79b$var$SIZE = 40;
function $b766c0138026c79b$var$Arrows(Splide2, Components2, options) {
    var event = $b766c0138026c79b$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var placeholder = _$Elements.arrows, track = _$Elements.track;
    var wrapper = placeholder;
    var prev = _$Elements.prev;
    var next = _$Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($b766c0138026c79b$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $b766c0138026c79b$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $b766c0138026c79b$var$display(wrapper, enabled ? "" : "none");
            $b766c0138026c79b$var$addClass(wrapper, wrapperClasses = $b766c0138026c79b$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $b766c0138026c79b$var$setAttribute([
                    prev,
                    next
                ], $b766c0138026c79b$var$ARIA_CONTROLS, track.id);
                emit($b766c0138026c79b$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $b766c0138026c79b$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $b766c0138026c79b$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $b766c0138026c79b$var$removeAttribute([
            prev,
            next
        ], $b766c0138026c79b$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $b766c0138026c79b$export$d300dc1a2634364b,
            $b766c0138026c79b$export$fe5802204b967f0d,
            $b766c0138026c79b$export$7f4701ac5e05e39f,
            $b766c0138026c79b$export$ff8164bff3202b9,
            $b766c0138026c79b$export$28dea85f216954dc
        ], update);
        bind(next, "click", $b766c0138026c79b$var$apply(go, ">"));
        bind(prev, "click", $b766c0138026c79b$var$apply(go, "<"));
    }
    function go(control) {
        _$Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $b766c0138026c79b$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $b766c0138026c79b$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $b766c0138026c79b$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $b766c0138026c79b$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $b766c0138026c79b$var$SIZE + " " + $b766c0138026c79b$var$SIZE + "\" width=\"" + $b766c0138026c79b$var$SIZE + "\" height=\"" + $b766c0138026c79b$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $b766c0138026c79b$var$PATH) + "\" />";
        return $b766c0138026c79b$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = _$Controller.getPrev();
            var nextIndex = _$Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $b766c0138026c79b$var$setAttribute(prev, $b766c0138026c79b$var$ARIA_LABEL, prevLabel);
            $b766c0138026c79b$var$setAttribute(next, $b766c0138026c79b$var$ARIA_LABEL, nextLabel);
            emit($b766c0138026c79b$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $b766c0138026c79b$var$INTERVAL_DATA_ATTRIBUTE = $b766c0138026c79b$var$DATA_ATTRIBUTE + "-interval";
function $b766c0138026c79b$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $b766c0138026c79b$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var _$Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $b766c0138026c79b$var$setAttribute(toggle, $b766c0138026c79b$var$ARIA_CONTROLS, _$Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $b766c0138026c79b$export$2aa493d7c3275167,
            $b766c0138026c79b$export$49801896908b5e33,
            $b766c0138026c79b$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($b766c0138026c79b$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($b766c0138026c79b$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($b766c0138026c79b$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $b766c0138026c79b$var$toggleClass(toggle, $b766c0138026c79b$export$72d36ecf3758cb4b, !stopped);
            $b766c0138026c79b$var$setAttribute(toggle, $b766c0138026c79b$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = _$Elements.bar;
        bar && $b766c0138026c79b$var$style(bar, "width", rate * 100 + "%");
        emit($b766c0138026c79b$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$b766c0138026c79b$var$getAttribute(Slide.slide, $b766c0138026c79b$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $b766c0138026c79b$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($b766c0138026c79b$export$9f64346e17f0ec8e, $b766c0138026c79b$var$apply(toggle, true));
            on([
                $b766c0138026c79b$export$d300dc1a2634364b,
                $b766c0138026c79b$export$db40ab7c0855fa5c,
                $b766c0138026c79b$export$7f4701ac5e05e39f
            ], $b766c0138026c79b$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $b766c0138026c79b$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $b766c0138026c79b$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $b766c0138026c79b$var$apply(cover, false)
    };
}
var $b766c0138026c79b$var$BOUNCE_DIFF_THRESHOLD = 10;
var $b766c0138026c79b$var$BOUNCE_DURATION = 600;
var $b766c0138026c79b$var$FRICTION_FACTOR = 0.6;
var $b766c0138026c79b$var$BASE_VELOCITY = 1.5;
var $b766c0138026c79b$var$MIN_DURATION = 800;
function $b766c0138026c79b$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, exceededLimit = _$Move.exceededLimit, translate = _$Move.translate;
    var isSlide = Splide2.is($b766c0138026c79b$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($b766c0138026c79b$export$2aa493d7c3275167, clear);
        on([
            $b766c0138026c79b$export$db40ab7c0855fa5c,
            $b766c0138026c79b$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $b766c0138026c79b$var$sign(destination) * size * $b766c0138026c79b$var$floor($b766c0138026c79b$var$abs(destination) / size) || 0;
            destination = _$Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $b766c0138026c79b$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $b766c0138026c79b$var$max($b766c0138026c79b$var$abs(destination - from) / $b766c0138026c79b$var$BASE_VELOCITY, $b766c0138026c79b$var$MIN_DURATION);
        callback = onScrolled;
        interval = $b766c0138026c79b$export$46ad21b25b6dccf0(duration, onEnd, $b766c0138026c79b$var$apply(update, from, destination, noConstrain), 1);
        set($b766c0138026c79b$var$SCROLLING);
        emit($b766c0138026c79b$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($b766c0138026c79b$var$IDLE);
        callback && callback();
        emit($b766c0138026c79b$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $b766c0138026c79b$var$FRICTION_FACTOR;
            if ($b766c0138026c79b$var$abs(diff) < $b766c0138026c79b$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $b766c0138026c79b$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $b766c0138026c79b$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $b766c0138026c79b$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var _$Move = Components2.Move, _$Scroll = Components2.Scroll, _$Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = _$Move.getPosition, exceededLimit = _$Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $b766c0138026c79b$var$POINTER_MOVE_EVENTS, $b766c0138026c79b$var$noop, $b766c0138026c79b$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $b766c0138026c79b$var$POINTER_UP_EVENTS, $b766c0138026c79b$var$noop, $b766c0138026c79b$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $b766c0138026c79b$var$POINTER_DOWN_EVENTS, onPointerDown, $b766c0138026c79b$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $b766c0138026c79b$var$prevent);
        on([
            $b766c0138026c79b$export$d300dc1a2634364b,
            $b766c0138026c79b$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!_$Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $b766c0138026c79b$var$MOVING,
                        $b766c0138026c79b$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $b766c0138026c79b$var$POINTER_MOVE_EVENTS, onPointerMove, $b766c0138026c79b$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $b766c0138026c79b$var$POINTER_UP_EVENTS, onPointerUp, $b766c0138026c79b$var$SCROLL_LISTENER_OPTIONS);
                    _$Move.cancel();
                    _$Scroll.cancel();
                    save(e);
                } else $b766c0138026c79b$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($b766c0138026c79b$var$DRAGGING)) {
            state.set($b766c0138026c79b$var$DRAGGING);
            emit($b766c0138026c79b$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                _$Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $b766c0138026c79b$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($b766c0138026c79b$export$8e9f636d2c722196);
                $b766c0138026c79b$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $b766c0138026c79b$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($b766c0138026c79b$var$DRAGGING)) {
            state.set($b766c0138026c79b$var$IDLE);
            emit($b766c0138026c79b$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $b766c0138026c79b$var$prevent(e);
        }
        unbind(target, $b766c0138026c79b$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $b766c0138026c79b$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $b766c0138026c79b$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) _$Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($b766c0138026c79b$export$742b62a5690c060)) _$Controller.go(orient($b766c0138026c79b$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($b766c0138026c79b$export$e5a58a5ee5b54c22) && exceeded && rewind) _$Controller.go(exceededLimit(true) ? ">" : "<");
        else _$Controller.go(_$Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $b766c0138026c79b$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $b766c0138026c79b$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $b766c0138026c79b$var$abs(diffCoord(e)) > $b766c0138026c79b$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($b766c0138026c79b$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $b766c0138026c79b$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $b766c0138026c79b$var$sign(velocity) * $b766c0138026c79b$var$min($b766c0138026c79b$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $b766c0138026c79b$var$timeOf(e) - $b766c0138026c79b$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($b766c0138026c79b$export$e5a58a5ee5b54c22) ? $b766c0138026c79b$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$b766c0138026c79b$var$matches(target2, "." + $b766c0138026c79b$export$52f2cca6a5eee805 + ", ." + $b766c0138026c79b$export$516e7d18e13a2dca) && (!noDrag || !$b766c0138026c79b$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $b766c0138026c79b$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $b766c0138026c79b$var$ARROW_RIGHT,
    Left: $b766c0138026c79b$var$ARROW_LEFT,
    Up: $b766c0138026c79b$var$ARROW_UP,
    Down: $b766c0138026c79b$var$ARROW_DOWN
};
function $b766c0138026c79b$var$normalizeKey(key) {
    key = $b766c0138026c79b$var$isString(key) ? key : key.key;
    return $b766c0138026c79b$var$NORMALIZATION_MAP[key] || key;
}
var $b766c0138026c79b$var$KEYBOARD_EVENT = "keydown";
function $b766c0138026c79b$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($b766c0138026c79b$export$db40ab7c0855fa5c, destroy);
        on($b766c0138026c79b$export$db40ab7c0855fa5c, init);
        on($b766c0138026c79b$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $b766c0138026c79b$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $b766c0138026c79b$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $b766c0138026c79b$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $b766c0138026c79b$var$normalizeKey(e);
            if (key === resolve($b766c0138026c79b$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($b766c0138026c79b$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $b766c0138026c79b$var$SRC_DATA_ATTRIBUTE = $b766c0138026c79b$var$DATA_ATTRIBUTE + "-lazy";
var $b766c0138026c79b$var$SRCSET_DATA_ATTRIBUTE = $b766c0138026c79b$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $b766c0138026c79b$var$IMAGE_SELECTOR = "[" + $b766c0138026c79b$var$SRC_DATA_ATTRIBUTE + "], [" + $b766c0138026c79b$var$SRCSET_DATA_ATTRIBUTE + "]";
function $b766c0138026c79b$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $b766c0138026c79b$export$fe5802204b967f0d,
        $b766c0138026c79b$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($b766c0138026c79b$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $b766c0138026c79b$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $b766c0138026c79b$var$queryAll(Slide.slide, $b766c0138026c79b$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $b766c0138026c79b$var$getAttribute(img, $b766c0138026c79b$var$SRC_DATA_ATTRIBUTE);
                var srcset = $b766c0138026c79b$var$getAttribute(img, $b766c0138026c79b$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $b766c0138026c79b$var$child(parent, "." + className) || $b766c0138026c79b$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $b766c0138026c79b$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $b766c0138026c79b$var$addClass(data[1].slide, $b766c0138026c79b$export$d22ec4ccb7996ba2);
        bind(img, "load error", $b766c0138026c79b$var$apply(onLoad, data));
        $b766c0138026c79b$var$setAttribute(img, "src", $b766c0138026c79b$var$getAttribute(img, $b766c0138026c79b$var$SRC_DATA_ATTRIBUTE));
        $b766c0138026c79b$var$setAttribute(img, "srcset", $b766c0138026c79b$var$getAttribute(img, $b766c0138026c79b$var$SRCSET_DATA_ATTRIBUTE));
        $b766c0138026c79b$var$removeAttribute(img, $b766c0138026c79b$var$SRC_DATA_ATTRIBUTE);
        $b766c0138026c79b$var$removeAttribute(img, $b766c0138026c79b$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $b766c0138026c79b$var$removeClass(Slide.slide, $b766c0138026c79b$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $b766c0138026c79b$var$remove(data[2]);
            $b766c0138026c79b$var$display(img, "");
            emit($b766c0138026c79b$export$9f64346e17f0ec8e, img, Slide);
            emit($b766c0138026c79b$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $b766c0138026c79b$var$apply($b766c0138026c79b$var$empty, entries),
        check: check
    };
}
function $b766c0138026c79b$var$Pagination(Splide2, Components2, options) {
    var event = $b766c0138026c79b$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var _$Slides = Components2.Slides, _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var hasFocus = _$Controller.hasFocus, getIndex = _$Controller.getIndex, go = _$Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = _$Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $b766c0138026c79b$export$db40ab7c0855fa5c,
            $b766c0138026c79b$export$7f4701ac5e05e39f,
            $b766c0138026c79b$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $b766c0138026c79b$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $b766c0138026c79b$export$2aa493d7c3275167,
                $b766c0138026c79b$export$49801896908b5e33,
                $b766c0138026c79b$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($b766c0138026c79b$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $b766c0138026c79b$var$remove(placeholder ? $b766c0138026c79b$var$slice(list.children) : list);
            $b766c0138026c79b$var$removeClass(list, paginationClasses);
            $b766c0138026c79b$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? _$Controller.getEnd() + 1 : $b766c0138026c79b$var$ceil(length / perPage);
        list = placeholder || $b766c0138026c79b$var$create("ul", classes.pagination, _$Elements.track.parentElement);
        $b766c0138026c79b$var$addClass(list, paginationClasses = $b766c0138026c79b$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $b766c0138026c79b$var$setAttribute(list, $b766c0138026c79b$var$ROLE, "tablist");
        $b766c0138026c79b$var$setAttribute(list, $b766c0138026c79b$var$ARIA_LABEL, i18n.select);
        $b766c0138026c79b$var$setAttribute(list, $b766c0138026c79b$var$ARIA_ORIENTATION, getDirection() === $b766c0138026c79b$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $b766c0138026c79b$var$create("li", null, list);
            var button = $b766c0138026c79b$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = _$Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $b766c0138026c79b$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $b766c0138026c79b$var$apply(onKeydown, i));
            $b766c0138026c79b$var$setAttribute(li, $b766c0138026c79b$var$ROLE, "presentation");
            $b766c0138026c79b$var$setAttribute(button, $b766c0138026c79b$var$ROLE, "tab");
            $b766c0138026c79b$var$setAttribute(button, $b766c0138026c79b$var$ARIA_CONTROLS, controls.join(" "));
            $b766c0138026c79b$var$setAttribute(button, $b766c0138026c79b$var$ARIA_LABEL, $b766c0138026c79b$var$format(text, i + 1));
            $b766c0138026c79b$var$setAttribute(button, $b766c0138026c79b$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $b766c0138026c79b$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($b766c0138026c79b$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($b766c0138026c79b$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $b766c0138026c79b$var$focus(item.button);
            go(">" + nextPage);
            $b766c0138026c79b$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[_$Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $b766c0138026c79b$var$removeClass(button, $b766c0138026c79b$export$72d36ecf3758cb4b);
            $b766c0138026c79b$var$removeAttribute(button, $b766c0138026c79b$var$ARIA_SELECTED);
            $b766c0138026c79b$var$setAttribute(button, $b766c0138026c79b$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $b766c0138026c79b$var$addClass(_button, $b766c0138026c79b$export$72d36ecf3758cb4b);
            $b766c0138026c79b$var$setAttribute(_button, $b766c0138026c79b$var$ARIA_SELECTED, true);
            $b766c0138026c79b$var$setAttribute(_button, $b766c0138026c79b$var$TAB_INDEX, "");
        }
        emit($b766c0138026c79b$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $b766c0138026c79b$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $b766c0138026c79b$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $b766c0138026c79b$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $b766c0138026c79b$export$f188226459c8a3ff(splide);
        event.on($b766c0138026c79b$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($b766c0138026c79b$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $b766c0138026c79b$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($b766c0138026c79b$export$5adb665701eda1ce, onClick);
        on($b766c0138026c79b$export$6d5af59619d10e6a, onKeydown);
        on([
            $b766c0138026c79b$export$d300dc1a2634364b,
            $b766c0138026c79b$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($b766c0138026c79b$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $b766c0138026c79b$var$setAttribute(Components2.Elements.list, $b766c0138026c79b$var$ARIA_ORIENTATION, options.direction === $b766c0138026c79b$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($b766c0138026c79b$var$includes($b766c0138026c79b$var$TRIGGER_KEYS, $b766c0138026c79b$var$normalizeKey(e))) {
            onClick(Slide);
            $b766c0138026c79b$var$prevent(e);
        }
    }
    return {
        setup: $b766c0138026c79b$var$apply(Components2.Media.set, {
            slideFocus: $b766c0138026c79b$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $b766c0138026c79b$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $b766c0138026c79b$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $b766c0138026c79b$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($b766c0138026c79b$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $b766c0138026c79b$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($b766c0138026c79b$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $b766c0138026c79b$var$SR_REMOVAL_DELAY = 90;
function $b766c0138026c79b$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $b766c0138026c79b$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $b766c0138026c79b$var$create("span", $b766c0138026c79b$export$bb78d7c200da8960);
    var interval = $b766c0138026c79b$export$46ad21b25b6dccf0($b766c0138026c79b$var$SR_REMOVAL_DELAY, $b766c0138026c79b$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $b766c0138026c79b$var$setAttribute(track, $b766c0138026c79b$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($b766c0138026c79b$export$23663268a31b79e2, $b766c0138026c79b$var$apply(disable, true));
            on($b766c0138026c79b$export$16a1e4f3d0368265, $b766c0138026c79b$var$apply(disable, false));
            on([
                $b766c0138026c79b$export$fe5802204b967f0d,
                $b766c0138026c79b$export$ff8164bff3202b9
            ], $b766c0138026c79b$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $b766c0138026c79b$var$setAttribute(track, $b766c0138026c79b$var$ARIA_BUSY, active);
        if (active) {
            $b766c0138026c79b$var$append(track, sr);
            interval.start();
        } else {
            $b766c0138026c79b$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $b766c0138026c79b$var$removeAttribute(track, [
            $b766c0138026c79b$var$ARIA_LIVE,
            $b766c0138026c79b$var$ARIA_ATOMIC,
            $b766c0138026c79b$var$ARIA_BUSY
        ]);
        $b766c0138026c79b$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $b766c0138026c79b$var$setAttribute(track, $b766c0138026c79b$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $b766c0138026c79b$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $b766c0138026c79b$var$Media,
    Direction: $b766c0138026c79b$var$Direction,
    Elements: $b766c0138026c79b$var$Elements,
    Slides: $b766c0138026c79b$var$Slides,
    Layout: $b766c0138026c79b$var$Layout,
    Clones: $b766c0138026c79b$var$Clones,
    Move: $b766c0138026c79b$var$Move,
    Controller: $b766c0138026c79b$var$Controller,
    Arrows: $b766c0138026c79b$var$Arrows,
    Autoplay: $b766c0138026c79b$var$Autoplay,
    Cover: $b766c0138026c79b$var$Cover,
    Scroll: $b766c0138026c79b$var$Scroll,
    Drag: $b766c0138026c79b$var$Drag,
    Keyboard: $b766c0138026c79b$var$Keyboard,
    LazyLoad: $b766c0138026c79b$var$LazyLoad,
    Pagination: $b766c0138026c79b$var$Pagination,
    Sync: $b766c0138026c79b$var$Sync,
    Wheel: $b766c0138026c79b$var$Wheel,
    Live: $b766c0138026c79b$var$Live
});
var $b766c0138026c79b$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $b766c0138026c79b$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $b766c0138026c79b$export$ba41d43e4a419565,
    i18n: $b766c0138026c79b$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $b766c0138026c79b$var$Fade(Splide2, Components2, options) {
    var _$Slides = Components2.Slides;
    function mount() {
        $b766c0138026c79b$export$f188226459c8a3ff(Splide2).on([
            $b766c0138026c79b$export$d300dc1a2634364b,
            $b766c0138026c79b$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        _$Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        _$Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $b766c0138026c79b$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $b766c0138026c79b$var$noop
    };
}
function $b766c0138026c79b$var$Slide(Splide2, Components2, options) {
    var _$Move = Components2.Move, _$Controller = Components2.Controller, _$Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $b766c0138026c79b$var$apply($b766c0138026c79b$var$style, list, "transition");
    var endCallback;
    function mount() {
        $b766c0138026c79b$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = _$Move.toPosition(index, true);
        var position = _$Move.getPosition();
        var speed = getSpeed(index);
        if ($b766c0138026c79b$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) _$Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                _$Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            _$Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        _$Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($b766c0138026c79b$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = _$Controller.getIndex(true);
            var end = _$Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $b766c0138026c79b$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $b766c0138026c79b$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $b766c0138026c79b$export$7254cc27399e90bd($b766c0138026c79b$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $b766c0138026c79b$var$isString(target) ? $b766c0138026c79b$var$query(document, target) : target;
        $b766c0138026c79b$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $b766c0138026c79b$var$merge({
            label: $b766c0138026c79b$var$getAttribute(root, $b766c0138026c79b$var$ARIA_LABEL) || "",
            labelledby: $b766c0138026c79b$var$getAttribute(root, $b766c0138026c79b$var$ARIA_LABELLEDBY) || ""
        }, $b766c0138026c79b$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $b766c0138026c79b$var$merge(options, JSON.parse($b766c0138026c79b$var$getAttribute(root, $b766c0138026c79b$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $b766c0138026c79b$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($b766c0138026c79b$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $b766c0138026c79b$var$assert(state.is([
            $b766c0138026c79b$var$CREATED,
            $b766c0138026c79b$var$DESTROYED
        ]), "Already mounted!");
        state.set($b766c0138026c79b$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($b766c0138026c79b$export$742b62a5690c060) ? $b766c0138026c79b$var$Fade : $b766c0138026c79b$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $b766c0138026c79b$var$assign({}, $b766c0138026c79b$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $b766c0138026c79b$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $b766c0138026c79b$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($b766c0138026c79b$export$d300dc1a2634364b);
        $b766c0138026c79b$var$addClass(this.root, $b766c0138026c79b$export$7761661e2d5b9388);
        state.set($b766c0138026c79b$var$IDLE);
        this.emit($b766c0138026c79b$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($b766c0138026c79b$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($b766c0138026c79b$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($b766c0138026c79b$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($b766c0138026c79b$var$CREATED)) $b766c0138026c79b$export$f188226459c8a3ff(this).on($b766c0138026c79b$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $b766c0138026c79b$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($b766c0138026c79b$export$88c4cf7419e470cd);
            event.destroy();
            completely && $b766c0138026c79b$var$empty(this.splides);
            state.set($b766c0138026c79b$var$DESTROYED);
        }
        return this;
    };
    $b766c0138026c79b$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $b766c0138026c79b$export$24494c7438c070bf = $b766c0138026c79b$var$_Splide;
$b766c0138026c79b$export$24494c7438c070bf.defaults = {};
$b766c0138026c79b$export$24494c7438c070bf.STATES = $b766c0138026c79b$var$STATES;
var $b766c0138026c79b$var$CLASS_RENDERED = "is-rendered";
var $b766c0138026c79b$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $b766c0138026c79b$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $b766c0138026c79b$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $b766c0138026c79b$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $b766c0138026c79b$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $b766c0138026c79b$var$merge($b766c0138026c79b$export$f484e977a69c6ba6, defaults || {});
        $b766c0138026c79b$var$merge($b766c0138026c79b$var$merge(this.options, $b766c0138026c79b$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $b766c0138026c79b$var$assign({}, $b766c0138026c79b$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $b766c0138026c79b$var$uniqueId("splide");
        this.Style = new $b766c0138026c79b$var$Style(this.id, this.options);
        this.Direction = $b766c0138026c79b$var$Direction(null, null, this.options);
        $b766c0138026c79b$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $b766c0138026c79b$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $b766c0138026c79b$var$queryAll(root, "." + $b766c0138026c79b$export$2c1ba4a4f1aa4947);
        on($b766c0138026c79b$export$d300dc1a2634364b, function() {
            $b766c0138026c79b$var$remove($b766c0138026c79b$var$child(root, "style"));
        });
        $b766c0138026c79b$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $b766c0138026c79b$var$push(this.slides, this.contents.map(function(content, index) {
            content = $b766c0138026c79b$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $b766c0138026c79b$export$72d36ecf3758cb4b : "");
            $b766c0138026c79b$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $b766c0138026c79b$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $b766c0138026c79b$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $b766c0138026c79b$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $b766c0138026c79b$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $b766c0138026c79b$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $b766c0138026c79b$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $b766c0138026c79b$var$unit(padding[prop] || ($b766c0138026c79b$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $b766c0138026c79b$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $b766c0138026c79b$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $b766c0138026c79b$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $b766c0138026c79b$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $b766c0138026c79b$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($b766c0138026c79b$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $b766c0138026c79b$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $b766c0138026c79b$var$merge($b766c0138026c79b$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $b766c0138026c79b$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $b766c0138026c79b$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $b766c0138026c79b$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $b766c0138026c79b$export$93b21159ad85c843,
            $b766c0138026c79b$export$93b21159ad85c843 + "--" + options.type,
            $b766c0138026c79b$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $b766c0138026c79b$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $b766c0138026c79b$export$93b21159ad85c843 + "--nav",
            $b766c0138026c79b$export$72d36ecf3758cb4b,
            !this.config.hidden && $b766c0138026c79b$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $b766c0138026c79b$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $b766c0138026c79b$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $b766c0138026c79b$var$forOwn(styles, function(value, key) {
            style += " " + $b766c0138026c79b$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$b766c0138026c79b$var$push(slides, slides);
        $b766c0138026c79b$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $b766c0138026c79b$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $b766c0138026c79b$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $b766c0138026c79b$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $b766c0138026c79b$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $b766c0138026c79b$var$SIZE + " " + $b766c0138026c79b$var$SIZE + "\" width=\"" + $b766c0138026c79b$var$SIZE + "\" height=\"" + $b766c0138026c79b$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $b766c0138026c79b$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ 
var $2l5av = parcelRequire("2l5av");

var $aqUTs = parcelRequire("aqUTs");
function $00db0beb44eb2d08$var$empty(array) {
    array.length = 0;
}
function $00db0beb44eb2d08$var$slice$1(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $00db0beb44eb2d08$var$apply$1(func) {
    return func.bind.apply(func, [
        null
    ].concat($00db0beb44eb2d08$var$slice$1(arguments, 1)));
}
function $00db0beb44eb2d08$var$raf(func) {
    return requestAnimationFrame(func);
}
function $00db0beb44eb2d08$var$typeOf$1(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $aqUTs._)(subject)) === type;
}
var $00db0beb44eb2d08$var$isArray$1 = Array.isArray;
$00db0beb44eb2d08$var$apply$1($00db0beb44eb2d08$var$typeOf$1, "function");
$00db0beb44eb2d08$var$apply$1($00db0beb44eb2d08$var$typeOf$1, "string");
$00db0beb44eb2d08$var$apply$1($00db0beb44eb2d08$var$typeOf$1, "undefined");
function $00db0beb44eb2d08$var$toArray$1(value) {
    return $00db0beb44eb2d08$var$isArray$1(value) ? value : [
        value
    ];
}
function $00db0beb44eb2d08$var$forEach$1(values, iteratee) {
    $00db0beb44eb2d08$var$toArray$1(values).forEach(iteratee);
}
var $00db0beb44eb2d08$var$ownKeys$1 = Object.keys;
function $00db0beb44eb2d08$var$forOwn$1(object, iteratee, right) {
    if (object) {
        var keys = $00db0beb44eb2d08$var$ownKeys$1(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $00db0beb44eb2d08$var$assign$1(object) {
    $00db0beb44eb2d08$var$slice$1(arguments, 1).forEach(function(source) {
        $00db0beb44eb2d08$var$forOwn$1(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
var $00db0beb44eb2d08$var$min$1 = Math.min;
function $00db0beb44eb2d08$var$EventBinder() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $00db0beb44eb2d08$var$forEach$1(targets, function(target) {
            target && $00db0beb44eb2d08$var$forEach$1(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $00db0beb44eb2d08$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $00db0beb44eb2d08$var$EVENT_MOVE = "move";
var $00db0beb44eb2d08$var$EVENT_MOVED = "moved";
var $00db0beb44eb2d08$var$EVENT_UPDATED = "updated";
var $00db0beb44eb2d08$var$EVENT_DRAG = "drag";
var $00db0beb44eb2d08$var$EVENT_DRAGGED = "dragged";
var $00db0beb44eb2d08$var$EVENT_SCROLL = "scroll";
var $00db0beb44eb2d08$var$EVENT_SCROLLED = "scrolled";
var $00db0beb44eb2d08$var$EVENT_DESTROY = "destroy";
function $00db0beb44eb2d08$var$EventInterface(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $00db0beb44eb2d08$var$EventBinder();
    function on(events, callback) {
        binder.bind(bus, $00db0beb44eb2d08$var$toArray$1(events).join(" "), function(e) {
            callback.apply(callback, $00db0beb44eb2d08$var$isArray$1(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $00db0beb44eb2d08$var$slice$1(arguments, 1));
    }
    if (Splide2) Splide2.event.on($00db0beb44eb2d08$var$EVENT_DESTROY, binder.destroy);
    return $00db0beb44eb2d08$var$assign$1(binder, {
        bus: bus,
        on: on,
        off: $00db0beb44eb2d08$var$apply$1(binder.unbind, bus),
        emit: emit
    });
}
function $00db0beb44eb2d08$var$RequestInterval(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $00db0beb44eb2d08$var$min$1((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            $00db0beb44eb2d08$var$raf(update);
        }
    }
    function start(resume) {
        !resume && cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        $00db0beb44eb2d08$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $00db0beb44eb2d08$var$Throttle(func, duration) {
    var interval;
    function throttled() {
        if (!interval) {
            interval = $00db0beb44eb2d08$var$RequestInterval(duration || 0, function() {
                func();
                interval = null;
            }, null, 1);
            interval.start();
        }
    }
    return throttled;
}
var $00db0beb44eb2d08$var$CLASS_ACTIVE = "is-active";
var $00db0beb44eb2d08$var$SLIDE = "slide";
var $00db0beb44eb2d08$var$FADE = "fade";
function $00db0beb44eb2d08$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $00db0beb44eb2d08$var$apply(func) {
    var _func;
    return (_func = func).bind.apply(_func, [
        null
    ].concat((0, $2l5av._)($00db0beb44eb2d08$var$slice(arguments, 1))));
}
function $00db0beb44eb2d08$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $aqUTs._)(subject)) === type;
}
function $00db0beb44eb2d08$var$isObject(subject) {
    return !$00db0beb44eb2d08$var$isNull(subject) && $00db0beb44eb2d08$var$typeOf("object", subject);
}
var $00db0beb44eb2d08$var$isArray = Array.isArray;
$00db0beb44eb2d08$var$apply($00db0beb44eb2d08$var$typeOf, "function");
$00db0beb44eb2d08$var$apply($00db0beb44eb2d08$var$typeOf, "string");
var $00db0beb44eb2d08$var$isUndefined = $00db0beb44eb2d08$var$apply($00db0beb44eb2d08$var$typeOf, "undefined");
function $00db0beb44eb2d08$var$isNull(subject) {
    return subject === null;
}
function $00db0beb44eb2d08$var$toArray(value) {
    return $00db0beb44eb2d08$var$isArray(value) ? value : [
        value
    ];
}
function $00db0beb44eb2d08$var$forEach(values, iteratee) {
    $00db0beb44eb2d08$var$toArray(values).forEach(iteratee);
}
function $00db0beb44eb2d08$var$toggleClass(elm, classes, add) {
    if (elm) $00db0beb44eb2d08$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
var $00db0beb44eb2d08$var$ownKeys = Object.keys;
function $00db0beb44eb2d08$var$forOwn(object, iteratee, right) {
    if (object) {
        var keys = $00db0beb44eb2d08$var$ownKeys(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $00db0beb44eb2d08$var$assign(object) {
    $00db0beb44eb2d08$var$slice(arguments, 1).forEach(function(source) {
        $00db0beb44eb2d08$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $00db0beb44eb2d08$var$removeAttribute(elms, attrs) {
    $00db0beb44eb2d08$var$forEach(elms, function(elm) {
        $00db0beb44eb2d08$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $00db0beb44eb2d08$var$setAttribute(elms, attrs, value) {
    if ($00db0beb44eb2d08$var$isObject(attrs)) $00db0beb44eb2d08$var$forOwn(attrs, function(value2, name) {
        $00db0beb44eb2d08$var$setAttribute(elms, name, value2);
    });
    else $00db0beb44eb2d08$var$forEach(elms, function(elm) {
        $00db0beb44eb2d08$var$isNull(value) || value === "" ? $00db0beb44eb2d08$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
var $00db0beb44eb2d08$var$min = Math.min, $00db0beb44eb2d08$var$max = Math.max, $00db0beb44eb2d08$var$floor = Math.floor, $00db0beb44eb2d08$var$ceil = Math.ceil, $00db0beb44eb2d08$var$abs = Math.abs;
function $00db0beb44eb2d08$var$clamp(number, x, y) {
    var minimum = $00db0beb44eb2d08$var$min(x, y);
    var maximum = $00db0beb44eb2d08$var$max(x, y);
    return $00db0beb44eb2d08$var$min($00db0beb44eb2d08$var$max(minimum, number), maximum);
}
var $00db0beb44eb2d08$var$DEFAULTS = {
    speed: 1,
    autoStart: true,
    pauseOnHover: true,
    pauseOnFocus: true
};
var $00db0beb44eb2d08$var$I18N = {
    startScroll: "Start auto scroll",
    pauseScroll: "Pause auto scroll"
};
function $00db0beb44eb2d08$export$3fb39aee5567f02e(Splide2, Components2, options) {
    var _EventInterface = $00db0beb44eb2d08$var$EventInterface(Splide2), on = _EventInterface.on, off = _EventInterface.off, bind = _EventInterface.bind, unbind = _EventInterface.unbind;
    var _Components2_Move = Components2.Move, translate = _Components2_Move.translate, getPosition = _Components2_Move.getPosition, toIndex = _Components2_Move.toIndex, getLimit = _Components2_Move.getLimit;
    var _Components2_Controller = Components2.Controller, setIndex = _Components2_Controller.setIndex, getIndex = _Components2_Controller.getIndex;
    var orient = Components2.Direction.orient;
    var toggle = Components2.Elements.toggle;
    var Live = Components2.Live;
    var root = Splide2.root;
    var throttledUpdateArrows = $00db0beb44eb2d08$var$Throttle(Components2.Arrows.update, 500);
    var autoScrollOptions = {};
    var interval;
    var stopped;
    var hovered;
    var focused;
    var busy;
    var currPosition;
    function setup() {
        var autoScroll = options.autoScroll;
        autoScrollOptions = $00db0beb44eb2d08$var$assign({}, $00db0beb44eb2d08$var$DEFAULTS, $00db0beb44eb2d08$var$isObject(autoScroll) ? autoScroll : {});
    }
    function mount() {
        if (!Splide2.is($00db0beb44eb2d08$var$FADE)) {
            if (!interval && options.autoScroll !== false) {
                interval = $00db0beb44eb2d08$var$RequestInterval(0, move);
                listen();
                autoStart();
            }
        }
    }
    function destroy() {
        if (interval) {
            interval.cancel();
            interval = null;
            currPosition = void 0;
            off([
                $00db0beb44eb2d08$var$EVENT_MOVE,
                $00db0beb44eb2d08$var$EVENT_DRAG,
                $00db0beb44eb2d08$var$EVENT_SCROLL,
                $00db0beb44eb2d08$var$EVENT_MOVED,
                $00db0beb44eb2d08$var$EVENT_SCROLLED
            ]);
            unbind(root, "mouseenter mouseleave focusin focusout");
            unbind(toggle, "click");
        }
    }
    function listen() {
        if (autoScrollOptions.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (autoScrollOptions.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (autoScrollOptions.useToggleButton) bind(toggle, "click", function() {
            stopped ? play() : pause();
        });
        on($00db0beb44eb2d08$var$EVENT_UPDATED, update);
        on([
            $00db0beb44eb2d08$var$EVENT_MOVE,
            $00db0beb44eb2d08$var$EVENT_DRAG,
            $00db0beb44eb2d08$var$EVENT_SCROLL
        ], function() {
            busy = true;
            pause(false);
        });
        on([
            $00db0beb44eb2d08$var$EVENT_MOVED,
            $00db0beb44eb2d08$var$EVENT_DRAGGED,
            $00db0beb44eb2d08$var$EVENT_SCROLLED
        ], function() {
            busy = false;
            autoToggle();
        });
    }
    function update() {
        var autoScroll = options.autoScroll;
        if (autoScroll !== false) {
            autoScrollOptions = $00db0beb44eb2d08$var$assign({}, autoScrollOptions, $00db0beb44eb2d08$var$isObject(autoScroll) ? autoScroll : {});
            mount();
        } else destroy();
        if (interval && !$00db0beb44eb2d08$var$isUndefined(currPosition)) translate(currPosition);
    }
    function autoStart() {
        if (autoScrollOptions.autoStart) {
            if (document.readyState === "complete") play();
            else bind(window, "load", play);
        }
    }
    function play() {
        if (isPaused()) {
            interval.start(true);
            Live.disable(true);
            focused = hovered = stopped = false;
            updateButton();
        }
    }
    function pause() {
        var stop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (!stopped) {
            stopped = stop;
            updateButton();
            if (!isPaused()) {
                interval.pause();
                Live.disable(false);
            }
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused || busy ? pause(false) : play();
    }
    function move() {
        var position = getPosition();
        var destination = computeDestination(position);
        if (position !== destination) {
            translate(destination);
            updateIndex(currPosition = getPosition());
        } else {
            pause(false);
            if (autoScrollOptions.rewind) Splide2.go(autoScrollOptions.speed > 0 ? 0 : Components2.Controller.getEnd());
        }
        throttledUpdateArrows();
    }
    function computeDestination(position) {
        var speed = autoScrollOptions.speed || 1;
        position += orient(speed);
        if (Splide2.is($00db0beb44eb2d08$var$SLIDE)) position = $00db0beb44eb2d08$var$clamp(position, getLimit(false), getLimit(true));
        return position;
    }
    function updateIndex(position) {
        var length = Splide2.length;
        var index = (toIndex(position) + length) % length;
        if (index !== getIndex()) {
            setIndex(index);
            Components2.Slides.update();
            Components2.Pagination.update();
            options.lazyLoad === "nearby" && Components2.LazyLoad.check();
        }
    }
    function updateButton() {
        if (toggle) {
            var key = stopped ? "startScroll" : "pauseScroll";
            $00db0beb44eb2d08$var$toggleClass(toggle, $00db0beb44eb2d08$var$CLASS_ACTIVE, !stopped);
            $00db0beb44eb2d08$var$setAttribute(toggle, "aria-label", options.i18n[key] || $00db0beb44eb2d08$var$I18N[key]);
        }
    }
    function isPaused() {
        return !interval || interval.isPaused();
    }
    return {
        setup: setup,
        mount: mount,
        destroy: destroy,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}


(0, $b766c0138026c79b$export$24494c7438c070bf).defaults = {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '1rem',
    pagination: false
};
jQuery(function($) {
    var sliders = document.querySelectorAll('.splide');
    sliders.forEach(function(slider) {
        if (slider.classList.contains('marquee')) new (0, $b766c0138026c79b$export$24494c7438c070bf)(slider, {
            drag: 'free',
            focus: 'center',
            perPage: null,
            autoWidth: true,
            autoScroll: {
                speed: 1
            }
        }).mount({
            AutoScroll: (0, $00db0beb44eb2d08$export$3fb39aee5567f02e)
        });
        else new (0, $b766c0138026c79b$export$24494c7438c070bf)(slider).mount();
    });
});

})();
//# sourceMappingURL=carousels.js.map
